// @flow

import * as React from 'react'
import { Grid, Segment, Button, Input } from 'semantic-ui-react'
import CampaignCard from './campaign-card'

import './ghost-campaign-card.css'

type InlineInputProps = {|
  onKeyDown: (SyntheticEvent<*>) => void,
  onBlur: (SyntheticEvent<*>) => void,
  onChange: (SyntheticEvent<*>, element: React.Element<*>) => void,
  value: string,
|}

class InlineInput extends React.Component<InlineInputProps> {
  textInput: ?HTMLInputElement

  componentDidMount() {
    if (this.textInput) this.textInput.focus()
  }
  render() {
    return (
      <Input
        transparent
        className="ghost-card"
        placeholder="Nome campagna..."
        onKeyDown={this.props.onKeyDown}
        onBlur={this.props.onBlur}
        onChange={this.props.onChange}
        value={this.props.value}
        ref={input => {
          this.textInput = input
        }}
      />
    )
  }
}

type GhostCampaignCardProps = {|
  onCommit: (value: string) => void,
  viewType: 'list' | 'grid' | 'block',
|}
type GhostCampaignCardState = {|
  editable: boolean,
  value: string,
|}

class GhostCampaignCard extends React.Component<GhostCampaignCardProps, GhostCampaignCardState> {
  static defaultProps = {
    onCommit: (value: string) => {},
  }
  state = { editable: false, value: '' }

  toggleEditing = () => {
    this.setState({ editable: !this.state.editable })
    if (!this.state.editable) {
      this.setState({ value: '' })
    }
  }

  onKeyDown = (e: SyntheticEvent<*>) => {
    if (e.keyCode === 27) {
      this.toggleEditing()
    }
    if (e.keyCode === 13) {
      this.toggleEditing()
      if (this.state.value.trim()) {
        this.props.onCommit(this.state.value)
      }
    }
  }
  onBlur = (e: SyntheticEvent<*>) => {
    this.toggleEditing()
  }
  onChange = (e: SyntheticEvent<*>, element: React.Element<*>) => {
    if (element) {
      this.setState({
        value: (element.value || '').toUpperCase().replace(' ', '_'),
      })
    }
  }

  render() {
    let elem = null
    if (!this.state.editable) {
      elem = (
        <Grid.Column>
          <Segment basic style={{ border: 'dashed 3px #c8c8c8', borderRadius: '10px' }}>
            <div style={{ textAlign: 'center', padding: '5ex 0' }}>
              <Button circular size="huge" style={{ color: 'white' }} onClick={this.toggleEditing}>
                Aggiungi campagna
              </Button>
            </div>
          </Segment>
        </Grid.Column>
      )
    } else {
      let nameInput = (
        <InlineInput
          onKeyDown={this.onKeyDown}
          onBlur={this.onBlur}
          onChange={this.onChange}
          value={this.state.value}
        />
      )
      elem = (
        <CampaignCard
          isAdmin={true}
          isViewer={false}
          headerContent={nameInput}
          waves={[]}
          users={[]}
          systemUsers={[]}
          viewType={this.props.viewType}
        />
      )
    }
    return <Grid.Column>{elem}</Grid.Column>
  }
}

export default GhostCampaignCard



// WEBPACK FOOTER //
// ./src/campaigns/ghost-campaign-card.js